import { jsxs as a, jsx as e } from "@emotion/react/jsx-runtime";
import { BusinessModalContentContainer as m, LeftPart as h, RightPart as f } from "./BusinessModalContent.styled.js";
import { DeviceType as s, useDeviceType as B } from "../../../../hooks/useDeviceType.js";
import { useBusinessModalContext as g } from "../../BusinessModalContext.js";
import { useIsUserRoleProviderOrAdmin as x } from "../../hooks/useIsUserRoleProviderOrAdmin.js";
import { GroupsContent as y } from "../GroupsContent/GroupsContent.js";
import { BusinessesContent as C } from "../BusinessesContent/BusinessesContent.js";
const A = () => {
  const {
    displayGroups: t,
    displayBusinesses: n,
    variant: i,
    preFilters: l
  } = g(), o = i === "groupOnly", p = [s.Tablet, s.Mobile, s.MobileApp].includes(B()), r = x(), d = !!l?.searchOrg, u = !r || r && d, c = p && o ? "100%" : o ? "400px" : "240px";
  return /* @__PURE__ */ a(m, { children: [
    t && u && /* @__PURE__ */ e(h, { width: c, children: /* @__PURE__ */ e(y, {}) }),
    n && /* @__PURE__ */ e(f, { children: /* @__PURE__ */ e(C, {}) })
  ] });
};
export {
  A as BusinessModalContent
};
